/* global $:false */

var forbidden = function(core) {

    var _$container = $("#cob\\.forbidden");

    core.translate('cob.forbidden', ".forbidden-container", true);

    return{
        init: function() {
            _$container.removeClass("hidden");
        },
        resume: function() {
            _$container.removeClass("hidden");
        },
        pause: function() {
            _$container.addClass("hidden");
        },
        destroy: function() {
           //nothing to do here
        }
    };
};

export default forbidden;
